import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import Home from "./Pages/Home";
import AdminDashboard from "./Pages/Admin/AdminDashboard";
import Navbar from "./Components/Navbar";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import News from "./Pages/News";
import Unauthorized from "./Pages/Unauthorized";
import ProtectedAdminRoute from "./Routes/ProtectedRoutes";
import AdminLogin from "./Pages/AuthLogin";
import Footer from "./Pages/Footer";
import TermsAndConditions from "./Pages/TermsConditions";
import BlogDetail from "./Components/BlogDetail";
import PrivacyPolicyModal from "./Pages/PolicyTerms";
import {Analytics} from '@vercel/analytics/react';
import {Suspense} from 'react';
import {SpeedInsights} from "@vercel/speed-insights/react"

function App() {
    const adminDashboardPath = process.env.REACT_APP_ADMIN_ROUTE;
    const loginPath = process.env.REACT_APP_LOGIN_ROUTE;
    const location = useLocation();
    const hideNavigationRoutes = [adminDashboardPath,loginPath];


    return (
        <Suspense fallback={<div className="flex flex-col items-center justify-center h-screen text-gray-600">
            <svg
                className="animate-spin h-10 w-10 text-lime-600 mb-4"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
            >
                <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                ></circle>
                <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                ></path>
            </svg>
            <p className="text-lg font-semibold animate-pulse">Loading, please wait...</p>
        </div>}>
            <Analytics/>
            <SpeedInsights/>

            {!hideNavigationRoutes.includes(location.pathname) && <Navbar/>}


            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/aboutus" element={<About/>}/>
                <Route path="/contact" element={<Contact/>}/>
                <Route path="/news" element={<News/>}/>
                <Route path="/blog/:slug" element={<BlogDetail/>}/>
                <Route path="/privacy-policy" element={<PrivacyPolicyModal/>}/>
                <Route path="/terms-conditions" element={<TermsAndConditions/>}/>
                <Route path={loginPath} element={<AdminLogin/>}/>
                <Route path={adminDashboardPath} element={
                  <ProtectedAdminRoute>
                      <AdminDashboard />
                  </ProtectedAdminRoute>
              } />
              <Route path='/unauthorized' element={<Unauthorized />} />
              <Route path="*" element={<Navigate to="/" replace />} />

          </Routes>
          {!hideNavigationRoutes.includes(location.pathname) && <Footer />}
        </Suspense>
  );
}

export default App;
